import { AuthState, useIdentify } from '@hungryroot/customer';
import { useApiV2CustomerExperiments } from '../api/use-api-v2-get-customer-experiments';
import { type UseCustomerExperimentsType } from '../types';
import { useAnonymousWindowExperiments } from './useAnonymousWindowExperiments';

/**
 *
 * This hook just returns all of the experiments the CURRENT customer is enrolled into
 * This hook should not include any special processing or attempt to determine
 * enrollment for a specific experiment. This hook is used for analytics and o11y logging
 */
export function useCustomerExperiments(): UseCustomerExperimentsType {
  const { authState } = useIdentify();

  const customerIsAuthenticated = authState === AuthState.isAuthenticated;
  const customerIsAnonymous = authState === AuthState.isAnonymous;
  const customerIsLoading = authState === AuthState.isLoading;
  const customerIsError = authState === AuthState.isError;

  const authenticatedUserExperiments = useApiV2CustomerExperiments({
    enabled: customerIsAuthenticated === true,
  });

  const anonymousUserExperiments = useAnonymousWindowExperiments({
    enabled: customerIsAnonymous === true,
  });

  if (customerIsAnonymous === true) {
    return anonymousUserExperiments;
  }

  if (customerIsLoading === true) {
    return {
      isLoading: true,
      error: null,
      isError: false,
      data: undefined,
    };
  }

  if (customerIsError === true) {
    return {
      isLoading: true,
      error: {
        name: 'Error loading user',
        message: 'Error loading user',
      },
      isError: true,
      data: undefined,
    };
  }

  return authenticatedUserExperiments;
}
